import { useDispatch } from "react-redux";
import { onLogout } from "../../features/auth/presentation/store/auth/AuthThunk";
import { onDisconnectSocketMatch } from "../../features/match/presentation/store/MatchThunk";
import { AppDispatch } from "../store/store";
import { onDisconnectSocketChat } from "../../features/chat/presentation/store/ChatThunk";
import { onDisconnectPartnerSocket } from "../../features/settings/presentation/store/PartnerThunk";
import { onDisconnectSocketAdmin } from "../../features/admin/presentation/store/AdminThunk";
import { onDisconnectSocketNotification } from "../../features/notification/presentation/store/NotificationThunk";

const useLogout = () => {
	const dispatch: AppDispatch = useDispatch();

	const logout = () => {
		dispatch(onLogout());
		dispatch(onDisconnectSocketMatch());
		dispatch(onDisconnectSocketChat());
		dispatch(onDisconnectPartnerSocket());
		dispatch(onDisconnectSocketAdmin());
		dispatch(onDisconnectSocketNotification());
		dispatch({ type: "DESTROY_SESSION" });
	};

	return logout;
};

export default useLogout;
